import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { curationsApiPath } from './apiPath';

const GetCurationTabsVisibilityDataSchema = z.object({
  isVisible: z.boolean(),
});

const GetCurationTabsVisibilityResponseSchema = createApiResponseSchema(
  GetCurationTabsVisibilityDataSchema,
);

export type GetCurationTabsVisibilityResponse = z.infer<
  typeof GetCurationTabsVisibilityResponseSchema
>;

const GetCurationTabsVisibilityRequestSchema = z.object({
  snsTitle: z.string().min(1),
});

export type GetCurationTabsVisibilityRequest = z.infer<
  typeof GetCurationTabsVisibilityRequestSchema
>;

export const getCurationTabsVisibility = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetCurationTabsVisibilityRequestSchema),
    async (params: GetCurationTabsVisibilityRequest): Promise<GetCurationTabsVisibilityResponse> =>
      executeStandardRequest(async () =>
        privateHttpClient.get<GetCurationTabsVisibilityResponse>(
          urlJoin(curationsApiPath.getCurationTabsVisibility),
          {
            snsTitle: params.snsTitle,
          },
        ),
      ),
    validateApiResponse(GetCurationTabsVisibilityResponseSchema),
  ),
);
